module.exports = __webpack_public_path__ + "img/view_4.6a5566f0.jpg";